
<dn-progress-spinner text="" *ngIf="showSpinner"></dn-progress-spinner>